import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	HostBinding,
	OnDestroy,
	OnInit,
	ViewEncapsulation,
} from "@angular/core";
import { UntypedFormArray, UntypedFormBuilder, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { CoreState, SmartIdAuthTransactionAction, SmartIdAuthTransactionSelector } from "@obg/ngx.core";
import { OBG_VALIDATORS } from "@obg/ngx.ui.common";
import { ignoreNil } from "@obg/rxjs";
import { merge, Subscription } from "rxjs";
import { take, tap } from "rxjs/operators";

@Component({
	selector: "obg-m-smart-id-login-verification-container",
	templateUrl: "./smart-id-login-verification.container.html",
	styleUrls: ["./smart-id-login-verification.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class SmartIdLoginVerificationContainer implements OnInit, OnDestroy {
	@HostBinding("class.obg-m-smart-id-login-verification-form") hostCssClass = true;

	verificationFormArray = this.createForm();

	private data$$: Subscription | undefined;

	constructor(
		private formBuilder: UntypedFormBuilder,
		private store: Store<CoreState>,
		private changeDetector: ChangeDetectorRef,
		private smartIdAuthTransactionAction: SmartIdAuthTransactionAction
	) {}

	ngOnInit() {
		const getVerificationCode$ = this.store.select(SmartIdAuthTransactionSelector.getVerificationCode).pipe(
			ignoreNil(),
			take(1),
			tap((verificationCode) => this.fillVerificationCode(verificationCode))
		);

		this.data$$ = merge(getVerificationCode$).subscribe(() => this.changeDetector.markForCheck());
	}

	ngOnDestroy() {
		this.data$$?.unsubscribe();
	}

	submitCancel(): void {
		this.store.dispatch(this.smartIdAuthTransactionAction.cancelLastVerification());
	}

	private fillVerificationCode(code: string): void {
		if (code?.length !== 4) {
			return;
		}

		this.verificationFormArray.controls.forEach((control, index) => {
			control.setValue(code.substring(index, index + 1));
		});
	}

	private createForm(): UntypedFormArray {
		const commonValidators = [
			Validators.required,
			OBG_VALIDATORS.numeric,
			Validators.minLength(1),
			Validators.maxLength(1),
		];
		const initialValue = { value: "", disabled: true };

		return this.formBuilder.array([
			this.formBuilder.control(initialValue, commonValidators),
			this.formBuilder.control(initialValue, commonValidators),
			this.formBuilder.control(initialValue, commonValidators),
			this.formBuilder.control(initialValue, commonValidators),
		]);
	}
}
